import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ContentTemplatesAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  getExternalTemplateError() {
    const message = {
      body: 'GET_EXTERNAL_TEMPLATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createTemplateSuccess() {
    const message = {
      body: 'CONTENT_TEMPLATE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createTemplateError() {
    const message = {
      body: 'CONTENT_TEMPLATE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  editTemplateSuccess() {
    const message = {
      body: 'CONTENT_TEMPLATE_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editTemplateError() {
    const message = {
      body: 'CONTENT_TEMPLATE_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  deleteTemplateSuccess() {
    const message = {
      body: 'CONTENT_TEMPLATE_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteTemplateError() {
    const message = {
      body: 'CONTENT_TEMPLATE_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.content-templates')
  .service('contentTemplatesAlertsService', ContentTemplatesAlertsService);
